/** Vide : pas d'image configurée, valeur acceptée. Sinon, une adresse absolue http(s) — rejette
 * notamment une URL `data:` (image encodée en base64), qui gonflerait chaque feature enregistrée
 * côté API au lieu d'y stocker une simple URL (voir `AreaUrlSection.validateUrl`, même principe). */
export default function validateImageUrl(value: string): void {
	if (!value) return;

	let parsed: URL;

	try {
		parsed = new URL(value);
	} catch {
		throw new Error(`Adresse invalide — utilisez un format complet, ex. https://exemple.com/image.png`);
	}

	if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
		throw new Error(`L'adresse doit commencer par http:// ou https:// (utilisez le crayon de la miniature pour importer un fichier)`);
	}
}
